import React, { Component } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import { createReactRenderer } from 'helpers/react-renderer';
import MatrixAttributesSortableList from './MatrixAttributesSortableList';
import { addNewValues, checkAddNewValue, reorderValues } from './MatrixAttributesStore';

/**
 * Class to interact with the Matrix attributes editing and sorting
 */
export default class MatrixAttributes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      attributes: addNewValues(cloneDeep(this.props.attributes), this.props.isEditable),
    };

    this.onSortEnd = this.onSortEnd.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  /**
   * When the attribute is dropped, handle the order change
   * @param {String} attribute - name of the attribute
   * @param {Number} oldIndex - before drop index
   * @param {Number} newIndex - after drop index
   */
  onSortEnd(attribute, { oldIndex, newIndex }) {
    this.setState(reorderValues(attribute, oldIndex, newIndex));
    this.updateAttributeDisplay(attribute);
  }

  /**
   * Common update function when the attribute is sorted or if the text has changed
   * @param {String} attribute - name of the attribute
   * @param {Number} [index] - index of the changed value
   * @param {String} [text] - new input value
   */
  updateAttributeDisplay(attribute, index, text) {
    this.setState(checkAddNewValue(attribute, index, text));

    // Update gui_def to show "Save Changes" button as active
    window.viewFieldChanged('view');
  }

  /**
   * Handle the "Enter" keypress on input, it should trigger the save button
   * @param {Event} event
   */
  handleKeyPress(event) {
    if (!event.which || event.which !== 13) return;
    document.getElementById('saveButton').click();
  }

  render() {
    return (
      <div className="matrix-attributes">
        {Object.keys(this.state.attributes).map(attribute => {
          const order = JSON.stringify(this.state.attributes[attribute].order || []);
          const isSystem = this.state.attributes[attribute].system;
          return (
            <div key={`matrix-attribute-${attribute}`}>
              <div className={`matrix-attributes__header${!isSystem ? ' notranslate' : ''}`}>
                {attribute}
              </div>
              <MatrixAttributesSortableList
                data={this.state.attributes[attribute].data}
                name={attribute}
                isEditable={this.props.isEditable}
                lockAxis="y"
                lockToContainerEdges
                onSortEnd={indices => this.onSortEnd(attribute, indices)}
                // eslint-disable-next-line no-shadow
                onChangeText={(text, attribute, index) =>
                  this.updateAttributeDisplay(text, attribute, index)
                }
                onKeyPress={this.handleKeyPress}
                useDragHandle
              />
              {this.props.isEditable && (
                <input
                  type="hidden"
                  className="view_view"
                  readOnly
                  value={order}
                  name={`attribute${this.state.attributes[attribute].number}_order`}
                />
              )}
            </div>
          );
        }, this)}
      </div>
    );
  }
}

const RenderedComponent = createReactRenderer({
  component: MatrixAttributes,
  selector: '[data-react-root="MatrixAttributes"]',
});

history.onChangeState(
  { name: 'item_group.views.item_group', tab: 'setup', id: undefined },
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
